import _ from 'lodash';
import { createSelector } from 'reselect';

export const selectGameLoading = (state) => state.loading;
export const selectFreeGameProviders = createSelector(
  (state) => state.freeGameProviders,
  (freeGameProviders) => _.sortBy(freeGameProviders, 'providerName'),
);
export const selectFreeGamesV2Providers = createSelector(
  (state) => state.freeGamesV2Providers,
  (freeGameProviders) => _.sortBy(freeGameProviders, 'providerName'),
);
export const selectFreeGames = (state) => state.freeGames;
export const selectFreeGamesV2 = (state) => state.freeGamesV2;

export const selectFreeGameAmountRestrictions = (state) => state.freeGameAmountRestrictions;
export const selectFreeGamesV2AmountRestrictions = (state) => state.freeGamesV2AmountRestrictions;

export const selectFreeGameLoading = (state) => state.freeGameLoading;
export const selectFreeGameAmountLoading = (state) => state.freeGameAmountLoading;
